import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import DashboardLayout from "@/components/dashboard/DashboardLayout";
import ApplicationStatus from "@/components/dashboard/ApplicationStatus";
import AssessmentResults from "@/components/dashboard/AssessmentResults";
import AssessmentOverview from "@/components/dashboard/AssessmentOverview";
import AssessmentCategories from "@/components/dashboard/AssessmentCategories";
import AssessmentTimeline from "@/components/dashboard/AssessmentTimeline";
import AssessmentRecommendations from "@/components/dashboard/AssessmentRecommendations";
import AssignedConsultant from "@/components/dashboard/AssignedConsultant";

const Dashboard = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate("/signin");
    }
  }, [user, navigate]);

  if (!user) return null;

  return (
    <DashboardLayout>
      <div className="space-y-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Assessment Overview Card */}
          <div className="lg:col-span-2">
            <AssessmentOverview />
          </div>

          {/* Application Status Card */}
          <div className="lg:col-span-1">
            <ApplicationStatus />
          </div>
        </div>

        {/* Assigned Consultant */}
        <AssignedConsultant />

        {/* Assessment Categories Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <AssessmentCategories />
          <AssessmentResults />
        </div>

        {/* Timeline and Recommendations */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <AssessmentTimeline />
          <AssessmentRecommendations />
        </div>
      </div>
    </DashboardLayout>
  );
};

export default Dashboard;